module.exports = {"511181100":"绥山镇","511181101":"高桥镇","511181102":"罗目镇","511181103":"九里镇","511181104":"龙池镇","511181105":"乐都镇","511181106":"符溪镇","511181107":"峨山镇","511181108":"双福镇","511181109":"桂花桥镇","511181110":"大为镇","511181111":"胜利镇","511181200":"龙门乡","511181201":"川主乡","511181202":"沙溪乡","511181203":"新平乡","511181204":"普兴乡","511181205":"黄湾乡","511181400":"东方电气集团峨嵋半导体材料有限公司","511181401":"四川川投峨眉铁合金（集团）有限责任公司","511181402":"四川省食品药品学校","511181403":"五二五厂","511181404":"西南交大峨眉校区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511181.json
// module id = 2156
// module chunks = 0